import { BaseResourceDataProvider, DataProviderOperation } from './BaseResourceDataProvider';

export abstract class AdminResourceDataProvider extends BaseResourceDataProvider {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected getOperationName(resource: string, operation: DataProviderOperation): string {
    const operationName = super.getOperationName(resource, operation);
    const capitalizedOperationName = operationName.charAt(0).toUpperCase() + operationName.slice(1);
    return `admin${capitalizedOperationName}`;
  }
}
